import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import useFetchEligibleQBPAem from "../../../../shared/hooks/useFetchEligibleQBPAem";
import { errorConditionGTM } from "../../../Utils/googleTags";
import useFetchAEMContent from "../../../../../shared/hooks/useFetchAemContents";
import useFetchAemBrspdContents from "../../../../../shared/hooks/useFetchAemBrspdContents";
import ApiUrls from "../../../Utils/axr";

type EligibleQBPPaymentContentInitialStateType = {
    EligibleQBPPaymentContent: any;
    loading: boolean;
    error: any;
};
const initialState: EligibleQBPPaymentContentInitialStateType = {
    EligibleQBPPaymentContent: null,
    loading: false,
    error: null,
};

const host = window?.location?.host;
const file = 'eligible-payment-overall.json'

export const getEligibleQBPPaymentContent = createAsyncThunk(
    "get/eligible_payment_AEM/content",
    async () => {
        try {
            const response = await useFetchAemBrspdContents({
                [ApiUrls.aem_content]: `${file}?appName=${host}`,
            });
            return response?.data;
        } catch (error) {
            throw error;
        }
    }
);

const getEligibleQBPPaymentContentDetailSlice = createSlice({
    name: "get/eligible_payment_AEM/Details",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getEligibleQBPPaymentContent.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getEligibleQBPPaymentContent.fulfilled, (state, action) => {
            state.EligibleQBPPaymentContent = action.payload;
            state.loading = false;
            state.error = null;
        });
        builder.addCase(getEligibleQBPPaymentContent.rejected, (state, action) => {
            errorConditionGTM(
                "BRSPD_Fiber_EC_Flow",
                "non auth AEM content",
                action.error?.message,
                action?.type
            );
            state.EligibleQBPPaymentContent = null;
            state.loading = false;
            state.error = action.error;
        });
    },
});

export default getEligibleQBPPaymentContentDetailSlice.reducer;